import React, { useState } from "react";
import styled from "styled-components";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import CasinoIcon from "@mui/icons-material/Casino";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { CardGiftcard } from "@mui/icons-material";

const GanacolBottomMenu = ({ onAwardsClick, onPlaysClick, onRechargeClick, onCombosClick }) => {
  // 👉 opción activa
  const [active, setActive] = useState("recargar"); // default

  const handleClick = (key, callback) => {
    setActive(key);
    callback?.();
  };

  return (
    <Menu>
      <Item
        type="button"
        className={active === "combos" ? "button_active" : ""}
        onClick={() => handleClick("combos", onCombosClick)}
      >
        <CardGiftcard />
        <span className="label">Combos</span>
      </Item>

      {/* PREMIOS */}
      <Item
        type="button"
        className={active === "premios" ? "button_active" : ""}
        onClick={() => handleClick("premios", onAwardsClick)}
      >
        <EmojiEventsIcon />
        <span className="label">Premios</span>
      </Item>

      {/* JUGADAS */}
      <Item
        type="button"
        className={active === "jugadas" ? "button_active" : ""}
        onClick={() => handleClick("jugadas", onPlaysClick)}
      >
        <CasinoIcon />
        <span className="label">Jugadas</span>
      </Item>

      {/* RECARGAR */}
      <Item type="button" onClick={() => handleClick("recargar", onRechargeClick)}>
        <AutorenewIcon />
        <span className="label">Recargar</span>
      </Item>

      {/* INTERCAMBIOS (comentado) */}
      {/* 
      <Item
        type="button"
        className={active === "intercambios" ? "button_active" : ""}
        onClick={() => handleClick("intercambios")}
      >
        <SwapHorizIcon />
        <span className="label">Intercambios</span>
      </Item>
      */}
    </Menu>
  );
};

export default GanacolBottomMenu;

/* ===== styles ===== */

const Menu = styled.div`
  width: fit-content;
  max-width: min(900px, 100%);
  margin: 0 auto;

  background: rgba(255, 255, 255, 0.12);
  border-radius: 18px;
  padding: clamp(10px, 2.2vw, 14px);

  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  gap: clamp(6px, 1.8vw, 10px);

  overflow: hidden;
`;

const Item = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;

  display: grid;
  justify-items: center;
  align-content: center;
  gap: 6px;

  padding: clamp(8px, 2vw, 12px) clamp(6px, 1.4vw, 12px);
  border-radius: 14px;

  color: #fff;
  min-width: 0;
  transition: background 0.2s ease, color 0.2s ease, transform 0.1s ease;

  svg {
    font-size: clamp(18px, 5vw, 24px);
  }

  .label {
    width: 100%;
    text-align: center;
    font-weight: 800;
    font-size: clamp(10px, 2.8vw, 14px);
    white-space: normal;
    line-height: 1.05;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &:active {
    transform: scale(0.96);
  }

  &.button_active {
    background: #ebc84b;
    color: #132469;
  }
`;
